import { Promotion } from "./promotion.model";
import { TypeOffer } from "./typeOffer.model";

export interface IPromotionItem {
  id?: number;
  promotion?: Promotion;
  typeOffer?: TypeOffer;
  name?: string;
  value0?: string;
  value1?: string;
  value2?: string;
  value3?: string;
}

export class PromotionItem implements IPromotionItem {
  constructor(
    public id?: number,
    public promotion?: Promotion,
    public typeOffer?: TypeOffer,
    public name?: string,
    public value0?: string,
    public value1?: string,
    public value2?: string,
    public value3?: string,
  ) {
    this.id = id;
    this.promotion = promotion;
    this.typeOffer = typeOffer;
    this.name = name;
    this.value0 = value0;
    this.value1 = value1;
    this.value2 = value2;
    this.value3 = value3;
  }
}
